<div class="dialog-container" [style]="getDialogContainerStyles()">
  <div class="calendar">
    <div class="month-year-line">
      <span class="month-year">{{monthData.name}} {{monthData.year}}</span>
      <div class="arrows">
        <img src="assets/ic_arrows.svg" class="arrow double flip" title="Previous year" (click)="changeDate(-1, 'years')" />
        <img src="assets/content-icon/ic-07.svg" class="arrow" title="Previous month" (click)="changeDate(-1, 'months')" />
        <img src="assets/content-icon/ic-07.svg" class="arrow flip" title="Next month" (click)="changeDate(1, 'months')" />
        <img src="assets/ic_arrows.svg" class="arrow double" title="Next year" (click)="changeDate(1, 'years')" />
      </div>
    </div>
    <div class="weekday-labels">
      <div class="weekday-label" *ngFor="let label of dayNames">
        <span>{{label}}</span>
      </div>
    </div>
    <div class="month">
      <div class="week" *ngFor="let week of monthData.weeks">
        <div class="day selectable" *ngFor="let day of week"
          [ngClass]="{today: isToday(day), start: isStart(day), end: isEnd(day), inner: isInner(day), disabled: isDisabled(day),
                      hover: isHoverRange(day), 'hover-end': isHoverDay(day)}"
          (mouseenter)="mouseEntered(day)" (mouseleave)="mouseLeft(day)" (click)="dayClicked(day)">
          <span>{{day.dayOfMonth}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="buttons">
    <button mat-button class="text-button secondary" (click)="cancel()">{{data.cancelText || 'Cancel'}}</button>
    <button mat-button class="text-button" [disabled]="!canConfirm()" (click)="confirm()">{{data.confirmText || 'Confirm'}}</button>
  </div>
</div>